export default {
  title: "Real Bank Accounts ",
  subtitle: "Overview",
  path: "real_bank_accounts_overview",
  paragraphs: [
    "The real bank accounts are the accounts opened for you in the countries we operate, or in FacilitaPay’s bank or with our partners in other countries. It is also the bank account you have abroad to receive the money collected and converted in LATAM. Also, it is the real bank account which we will use to make a payout for your customer locally.",
    "Those are the accounts you will share with the customers to receive payments in Brazil, Mexico, Colombia and Chile. For payins, you will not need to register your customers bank accounts"
  ],
  request: {}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsOverview.js